// extracted by mini-css-extract-plugin
export default {"label":"_1Pplh___Label-module__label","horizontalStyle":"_1FIC-___Label-module__horizontalStyle","required":"_3lEEe___Label-module__required"};